import { loadProgressBar } from "axios-progress-bar";
import "axios-progress-bar/dist/nprogress.css";
import React, { useEffect, useState } from "react";
import { HashRouter as Router } from "react-router-dom";
import { toast } from "react-toastify";
import "./App.scss";
import { AppRoutes } from "./AppRoutes";
import { PreLoader } from "./modules/platform-components/PreLoader";
import { AppContextProvider } from "./context/AppContext";
import { SnackbarProvider } from "notistack";

function App() {
  let [loading, setLoading] = useState(true);
  useEffect(() => {
    loadProgressBar();
    toast.configure({
      autoClose: 3000,
      draggable: false,
      hideProgressBar: true,
      style: { width: "200px" },
      //etc you get the idea
    });
    setLoading(false);
  }, []);
  return loading ? (
    <PreLoader />
  ) : (
    <Router>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="App">
          <AppContextProvider>
            <AppRoutes />
          </AppContextProvider>
        </div>
      </SnackbarProvider>
    </Router>
  );
}

export default App;
